"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocaleStatusSupported = exports.getReleaseGatedLocaleStatusMessage = exports.releaseGatedLocales = void 0;
const i18n_core_1 = require("@medable/i18n-core");
const locales_1 = require("./locales");
const locales_utils_1 = require("./locales.utils");
const releaseGatedLocalesByStatus = {
    ready: new Set(['am-ET', 'so-SO']),
};
const allLocales = new Set(Object.values(locales_1.Locale));
const getLocaleForDisplayName = (locale) => {
    if (allLocales.has(locale)) {
        return locale;
    }
    return undefined;
};
const getLanguageName = (locale) => {
    const localeForDisplayName = getLocaleForDisplayName(locale);
    if (!localeForDisplayName) {
        return locale;
    }
    // Language display names are most reliable when using the language subtag (`hy`, `am`, `so`).
    const languageSubtag = localeForDisplayName.split('-')[0];
    const formattedLanguageFromSubtag = new i18n_core_1.DisplayNamesLanguage(locales_1.Locale.en_US).of(languageSubtag);
    if (formattedLanguageFromSubtag && formattedLanguageFromSubtag !== languageSubtag) {
        return formattedLanguageFromSubtag;
    }
    const { languageDisplayName } = (0, locales_utils_1.getLanguageAndRegionDisplayNames)({
        appLocale: locales_1.Locale.en_US,
        targetLocaleCode: localeForDisplayName,
    });
    return languageDisplayName || locale;
};
exports.releaseGatedLocales = Array.from(new Set(Object.values(releaseGatedLocalesByStatus).flatMap((locales) => Array.from(locales))));
const statusLabelMap = {
    ready: 'Ready',
};
const getReleaseGatedLocaleStatusMessage = (locale, status) => {
    if (!releaseGatedLocalesByStatus[status].has(locale)) {
        return undefined;
    }
    const language = getLanguageName(locale);
    const statusLabel = statusLabelMap[status];
    return `${language} cannot be marked as ${statusLabel} yet. Platform support for ${language} is not available in this release. This option will be enabled in a future release`;
};
exports.getReleaseGatedLocaleStatusMessage = getReleaseGatedLocaleStatusMessage;
const isLocaleStatusSupported = (locale, status) => {
    return !releaseGatedLocalesByStatus[status].has(locale);
};
exports.isLocaleStatusSupported = isLocaleStatusSupported;
//# sourceMappingURL=locale_status_support.js.map